import { message, Select } from 'antd'
import Transactions from '../../../../../api/Finance/Transactions'
import TransactionsUpload from '../../../../../components/Finance/Statements/Transactions/TransactionsUpload/TransactionsUpload'
import CSVTOJSON from 'csvtojson'
import withSort from '../../../../../elements/HOC/withSort'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import withUrlFetch from '../../../../../elements/Select/withUrlFetch'
import { isEmpty, omit, pick } from 'lodash'
import { idMaker, replaceAll } from '../../../../../modules/Utils'
import moment from 'moment'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'

class TransactionsUploadCont extends Component {
  ids = idMaker()
  state = {
    transactionUploadList: [],
    selection: [],
    current: 0,
    list: [],
    details: {},
    BankSelectCmp: Select,
  }
  fileReader = new FileReader()
  api = new Transactions()
  transactionUploadFormRef = React.createRef()
  mapCsvFields = (list, details) => {
    switch (details.template) {
      case 'bsp': {
        return list.map((transaction) => {
          let key = this.ids.next().value
          const d = {
            _key: key,
            _id: key,
            amount: parseFloat(transaction['Debit'] || transaction['Credit']),
            bank: details.bank,
            company: details.company,
            type: transaction['Credit'] ? 'credit' : 'debit',
            date: moment(transaction['Date'], 'DD/MM/YYYY').format(),
            notes: transaction['Description'],
            balance: parseFloat(transaction['Balance']),
            remittance: { ref: transaction['Description'] },
          }
          return {
            ...d,
            uploaded: transaction,
          }
        })
      }
      case 'dbs': {
        return list.map((transaction) => {
          let key = this.ids.next().value
          const d = {
            _key: key,
            _id: key,
            amount: parseFloat(transaction['Debit'] || transaction['Credit']),
            bank: details.bank,
            company: details.company,
            currency: details.currency,
            type: transaction['Credit'] ? 'credit' : 'debit',
            date: moment(transaction['Transaction Date'], 'DD-MMM-YYYY').format(),
            notes: transaction['Transaction Description 1'],
            balance: parseFloat(transaction['Running Balance']),
            remittance: { ref: transaction['Transaction Description 2'] },
          }
          return {
            ...d,
            uploaded: transaction,
          }
        })
      }
      case 'nba': {
        return list.map((transaction) => {
          let key = this.ids.next().value
          const d = {
            _key: key,
            _id: key,

            date: moment(transaction['field1'], 'DD MMM YYYY').format(),
            amount: parseFloat(transaction['field2']),
            bank: details.bank,
            company: details.company,
            currency: details.currency,
            type: transaction['field5'].includes('CREDIT') ? 'credit' : 'debit',
            notes: `${transaction['field6']}, ${transaction['field5']}`,
            balance: parseFloat(transaction['field7']),
            remittance: { ref: transaction['field6'] },
          }
          return {
            ...d,
            uploaded: transaction,
          }
        })
      }
      case 'hsbc': {
        return list.map((transaction) => {
          let key = this.ids.next().value
          const d = {
            _key: key,
            _id: key,
            amount: parseFloat(
              transaction[`Withdraw(${details.currency})`] || transaction[`Deposit(${details.currency})`]
            ),
            bank: details.bank,
            company: details.company,
            currency: details.currency,
            type: transaction[`Deposit(${details.currency})`] ? 'credit' : 'debit',
            date: moment(transaction['Date'], 'DD MMM YYYY').format(),
            balance: parseFloat(transaction[`Balance(${details.currency})`]),
            remittance: { ref: transaction['Description'] },
          }
          return {
            ...d,
            uploaded: transaction,
          }
        })
      }
      case 'rhb': {
        return list.map((transaction) => {
          let key = this.ids.next().value
          const d = {
            _key: key,
            _id: key,
            amount: parseFloat(transaction['Amount (DR)']) || parseFloat(transaction['Amount (CR)']),
            bank: details.bank,
            company: details.company,
            type: parseFloat(transaction['Amount (CR)']) > 0 ? 'credit' : 'debit',
            date: moment(transaction['Date'], 'DD-MM-YYYY').format(),
            notes: transaction['Trx. Description'] + '\t CSV uploaded.',
            balance: parseFloat(transaction['Balance']),
            remittance: { ref: transaction['Sender`s Name/Beneficiary`s Name'] },
          }
          return {
            ...d,
            uploaded: transaction,
          }
        })
      }
      case 'nbad': {
        return list.map((transaction) => {
          let key = this.ids.next().value
          const d = {
            _key: key,
            _id: key,
            amount:
              parseFloat(replaceAll(transaction['Debit'], ',', '')) ||
              parseFloat(replaceAll(transaction['Credit'], ',', '')),
            bank: details.bank,
            company: details.company,
            type: parseFloat(replaceAll(transaction['Credit'], ',', '')) > 0 ? 'credit' : 'debit',
            date: moment(transaction['Transaction Date'], 'DD/MM/YYYY').format('YYYY-MM-DD'),
            notes: transaction['Narrative'],
            balance: parseFloat(replaceAll(transaction['Running Balance'], ',', '')),
            remittance: { ref: transaction['Bank Reference'] },
          }
          return {
            ...d,
            uploaded: transaction,
          }
        })
      }
      case 'endb': {
        return list.map((transaction) => {
          let key = this.ids.next().value
          const d = {
            _key: key,
            _id: key,
            amount: parseFloat(transaction['Dr'][' Amount']) || parseFloat(transaction['Cr'][' Amount']),
            bank: details.bank,
            company: details.company,
            type: parseFloat(transaction['Cr'][' Amount']) > 0 ? 'credit' : 'debit',
            date: moment(transaction['Date'], 'DD-MMM-YYYY').format('YYYY-MM-DD'),
            notes: transaction['Description'] + '\n' + transaction['Customer Reference'],
            balance: parseFloat(transaction['Balance']),
            remittance: { ref: transaction['Bank Reference'] },
          }
          return {
            ...d,
            uploaded: transaction,
          }
        })
      }
      case 'lloyds': {
        return list.map((transaction) => {
          let key = this.ids.next().value
          let dateFormat = transaction['Transaction Date'].split('/')[2].length > 2 ? 'DD/MM/YYYY' : 'DD/MM/YY'
          const d = {
            _key: key,
            _id: key,
            amount: parseFloat(transaction['Debit Amount']) || parseFloat(transaction['Credit Amount']),
            bank: details.bank,
            company: details.company,
            type: parseFloat(transaction['Credit Amount']) > 0 ? 'credit' : 'debit',
            date: moment(transaction['Transaction Date'], dateFormat).format('YYYY-MM-DD'),
            notes: transaction['Transaction Type'] + '\n' + transaction['Transaction Description'],
            balance: parseFloat(transaction['Balance']),
            remittance: { ref: transaction['Transaction Description'] },
          }
          return {
            ...d,
            uploaded: transaction,
          }
        })
      }
      case 'macquarie': {
        return list.map((transaction) => {
          let key = this.ids.next().value
          const d = {
            _key: key,
            _id: key,
            bank: details.bank,
            //statement
            date: moment(transaction['Transaction Date'], 'DD MMM YYYY').format(),
            type: parseFloat(transaction['Credit']) > 0 ? 'credit' : 'debit',
            amount: parseFloat(transaction['Debit']) || parseFloat(transaction['Credit']),
            company: details.company,
            notes: `[${transaction['Category']} - ${transaction['Subcategory']}] ${transaction['Original Description']}, CSV uploaded.`,
            remittance: { ref: transaction['Details'] },
          }
          return {
            ...d,
            uploaded: transaction,
          }
        })
      }
      case 'starling': {
        return list.map((transaction) => {
          let key = this.ids.next().value
          const d = {
            _key: key,
            _id: key,
            bank: details.bank,
            company: details.company,
            date: moment(transaction['Date'], 'DD/MM/YYYY').format() || moment(transaction['Date'], 'D/M/YY').format(),
            remittance: { ref: transaction['Reference'] },
            amount: parseFloat(transaction['Amount (GBP)']),
            balance: parseFloat(transaction['Balance (GBP)']),
            type: parseFloat(transaction['Amount (GBP)']) > 0 ? 'credit' : 'debit',
            notes: `[${transaction['Counter Party']} - ${transaction['Spending Category']}] ${transaction['Type']}, CSV uploaded.`,
          }
          return {
            ...d,
            uploaded: transaction,
          }
        })
      }

      default:
        return []
    }
  }
  checkTransactionUploadForm = () => {
    return new Promise((res) => {
      this.transactionUploadFormRef.current.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.setState({ fetching: true })
            const { transactionUploadList } = this.state
            const list = this.mapCsvFields(transactionUploadList, values)
            let moments = list.map((d) => moment(d.date))

            const DBList = await this.api.listByFilter({
              company: values.company,
              bank: values.bank,
              dates: { start: moment.min(moments), end: moment.max(moments) },
            })
            this.setState({
              list: [...DBList.map((t) => omit(t, ['_id'])), ...list],
              toUploadList: list,
              selection: list.map((t) => t._key),
              details: values,
              fetching: false,
            })
            res(values)
          } catch (e) {
            console.error(e)
            this.setState({ fetching: false })
            message.error(e.errorMessage || 'Error in CSV')
          }
        }
      })
    })
  }
  onShowTransactionUpload = () => {
    this.setState({
      visibleTransactionUpload: true,
    })
  }
  onCancelTransactionUpload = () => {
    this.setState({
      visibleTransactionUpload: false,
      transactionUploadList: [],
      csvFileList: [],
    })
  }
  onFileLoadEnd = async () => {
    try {
      const content = this.fileReader.result
      const bankTemplate = this.state.bankTemplate
      console.log({ bankTemplate })
      const transactionUploadList = await CSVTOJSON({
        noheader: ['nba'].includes(bankTemplate),
      }).fromString(content)

      console.log(transactionUploadList, ['nba'].includes(bankTemplate))
      this.setState({
        transactionUploadList,
      })
    } catch (e) {
      message.error(e.errorMessage)
    }
  }
  onFileLoaded = async ({ file }) => {
    try {
      this.fileReader.onloadend = this.onFileLoadEnd
      if (file) {
        await this.fileReader.readAsText(file)
      }
    } catch (e) {
      message.error('Error Reading the file.')
    }
  }
  beforeUpload = (file, bankTemplate) => {
    this.setState({
      csvFileList: [file],
      bankTemplate,
    })
    return false
  }
  prev = () => {
    const current = this.state.current - 1
    this.setState({ current })
  }
  next = async () => {
    let valid = false
    switch (this.state.current) {
      case 0:
        valid = await this.checkTransactionUploadForm()
        break
      default:
        valid = true
    }
    if (valid) {
      const current = this.state.current + 1
      this.setState({ current })
    }
  }
  onChangeCompany = (company) => {
    const url = `corporates/banks/?status=Active` + (isEmpty(company) ? '' : `&owner=${company}`)
    const BankSelectCmp = compose(
      withUrlFetch({
        name: 'banks',
        url: url,
        cache: true,
        forceFetch: true,
      }),
      withSpinning,
      withSort
    )(CustomSelect)
    this.transactionUploadFormRef.current.resetFields(['bank._id'])
    this.setState({ company, BankSelectCmp, url })
  }

  submit = async () => {
    try {
      this.setState({
        submitting: true,
      })
      await this.api.uploadCSV(this.state.selection.map((s) => this.state.toUploadList.find((t) => t._key === s)))
      this.setState({
        submitting: false,
      })
      message.success('Uploaded!')
      this.props.history.replace({
        pathname: `"#/finance/statements/"`,
        hash: 'transactions',
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        submitting: false,
      })
    }
  }
  toggleSelection = (key) => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)]
    } else {
      selection.push(key)
    }
    this.setState({ selection })
  }
  toggleAll = () => {
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      const wrappedInstance = this.formRef.current.getWrappedInstance()
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach((item) => {
        selection.push(item._original._id)
      })
    }
    this.setState({ selectAll, selection })
  }
  isSelected = (key) => {
    return this.state.selection.includes(key)
  }

  render() {
    return (
      <TransactionsUpload
        {...this.state}
        {...pick(this, [
          'onTransactionUpload',
          'onChangeCompany',
          'checkTransactionUploadForm',
          'onShowTransactionUpload',
          'onCancelTransactionUpload',
          'onFileLoadEnd',
          'onFileLoaded',
          'beforeUpload',
          'transactionUploadFormRef',
          'prev',
          'next',
          'submit',
          'toggleSelection',
          'toggleAll',
          'isSelected',
        ])}
      />
    )
  }
}

TransactionsUploadCont.propTypes = {}
TransactionsUploadCont.defaultProps = {}

export default withRouter(TransactionsUploadCont)
